export default __webpack_public_path__ + "2ced046a1acc2efb33b0188740f2007c.png";